import React, { useContext } from "react";
import { appContext } from "../App";
import { Product } from "../model/Product";
import Afterpay from "./Afterpay";
import Button from "./Button";

const randomString = (length: number, chars: string) => {
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

const rndm = () => {
  return randomString(
    5,
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  );
};

function ProductThumb(props: { product: Product }) {
  const { product } = props;
  const { afterpay } = useContext(appContext);
  const random = rndm();
  return (
    <div className="wrapper-thumbnail col-xs-8 col-sm-6 col-md-4 col-lg-3">
      <div className="thumbnail">
        <div className="wrapper-thumbnail-img">
          <a href={`/${product.item_url}`} className="thumbnail-image">
            <img
              src={
                product.images && product.images.length > 0
                  ? product.images[0].ThumbURL
                  : ""
              }
              className="product-image"
              alt={product.name}
            />
          </a>
        </div>
        <div className="caption">
          <p className="price" itemProp="offers">
            <span itemProp="price">${product.default_price}</span>
            <meta itemProp="priceCurrency" content="AUD" />
          </p>
          {afterpay && (
            <Afterpay
              amount={Number(product.default_price)}
              payments={afterpay.payments}
              logoUrl={afterpay.logoUrl}
            />
          )}
          <span className="thumb-part-number">SKU: {product.sku}</span>
          <br />
          <h3 itemProp="name">
            <a href={`/${product.item_url}`} title={product.name}>
              {product.name}
            </a>
          </h3>
          <form className="form-inline buying-options">
            <input
              type="hidden"
              id={`sku${random}${product.sku}`}
              name={`sku${random}${product.sku}`}
              value={product.sku}
            />
            <input
              type="hidden"
              id={`model${random}${product.sku}`}
              name={`model${random}${product.sku}`}
              value={product.model}
            />
            <input
              type="hidden"
              id={`thumb${random}${product.sku}`}
              name={`thumb${random}${product.sku}`}
              value={
                product.images && product.images.length > 0
                  ? product.images[0].ThumbURL
                  : ""
              }
            />
            <input
              type="number"
              id={`qty${random}${product.sku}`}
              name={`qty${random}${product.sku}`}
              className="input-tiny"
              defaultValue="1"
            />
            <Button
              type="button"
              title="Add to Cart"
              className="addtocart btn-primary btn btn-block btn-loads"
              data-loading-text="<i className='fa fa-spinner fa-spin' style='font-size: 14px'></i>"
              rel={`${random}${product.sku}`}
            >
              Add to Cart
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProductThumb;
